import { Row, TableToggleAllRowsSelectedProps } from "react-table";
import { Checkbox } from "../../../form/fields/Checkbox";
import SelectionContext from "../components/Table/contexts/SelectionContext";

import styles from "./style.module.scss";

const SelectionColumn = {
  id: "selection",
  disableResizing: true,
  hideInSettings: true,
  freezeOnScroll: true,
  minWidth: 40,
  width: 40,
  maxWidth: 45,
  Header: ({ getToggleAllPageRowsSelectedProps }: { getToggleAllPageRowsSelectedProps: () => TableToggleAllRowsSelectedProps }) => {
    return (
      <SelectionContext.Consumer>
        {
          () => (
            <Checkbox {...getToggleAllPageRowsSelectedProps?.()} />
          )
        }
      </SelectionContext.Consumer>
    );
  },
  Cell: ({ row }: { row: Row }) => {
    return (
      <SelectionContext.Consumer>
        {
          () => (
            <div className={styles.root}>
              <Checkbox {...row.getToggleRowSelectedProps?.()} />
            </div>
          )
        }
      </SelectionContext.Consumer>
    );
  },
};

export default SelectionColumn;
